
<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <EventTimeLine :timeIndex="status"></EventTimeLine>
      </zj-layout-header>
      <zj-layout-main>
          <EventInfo
            :EventConfirm="EventConfirm"
            :EventInfoEdit="EventInfoEdit"
            :EventSourceEdit="EventSourceEdit"
            :EventAffectEdit="EventAffectEdit"
            :IsConfirm="IsConfirm"
            :EventReport="EventReport"
          ></EventInfo>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>
<script>
import EventTimeLine from "./EventTimeLine.vue";
import EventInfo from "./EventInfo.vue";
export default {
  name: "ZjConfirmEvent",
  controller: "UI",
  action: "ConfirmEvent",
  components: {
    EventTimeLine,
    EventInfo
  },
  data() {
    return {
      status: 1,
      EventConfirm: true,
      EventInfoEdit: true,
      EventSourceEdit: true,
      EventAffectEdit: true,
      IsConfirm: true,
      EventReport: false
    };
  }
};
</script>